import { ExternalLink } from 'lucide-react'

interface CreatorLinksProps {
  variant?: 'hero' | 'compact' | 'footer' | 'controls'
}

export function CreatorLinks({ variant = 'compact' }: CreatorLinksProps) {
  const links = [
    { href: 'https://www.linkedin.com/in/mindful-abhay/', label: 'LinkedIn', short: 'in' },
    { href: 'https://buymeacoffee.com/abhaypratapsingh', label: 'Buy me a coffee', short: 'coffee' },
  ]

  if (variant === 'hero') {
    return (
      <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-[var(--text-muted)]">
        <span className="text-[var(--text-subtle)]">A cognitive instrument by</span>
        <a href={links[0].href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 hover:text-[var(--accent)] underline-offset-2 hover:underline">
          Abhay Pratap Singh <ExternalLink size={13} />
        </a>
        <span className="text-[var(--text-subtle)]">•</span>
        <a href={links[1].href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 hover:text-[var(--accent)] underline-offset-2 hover:underline">
          Support the work <ExternalLink size={13} />
        </a>
      </div>
    )
  }

  if (variant === 'controls') {
    return (
      <div className="text-[11px] text-[var(--text-subtle)] space-x-3">
        <a href={links[0].href} target="_blank" rel="noopener" className="hover:text-[var(--accent)]">LinkedIn</a>
        <span>·</span>
        <a href={links[1].href} target="_blank" rel="noopener" className="hover:text-[var(--accent)]">Buy me a coffee</a>
      </div>
    )
  }

  if (variant === 'footer') {
    return (
      <div className="flex items-center gap-4 text-[11px] text-[var(--text-subtle)]">
        <span>Crafted with care by Abhay Pratap Singh</span>
        <a href={links[0].href} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--accent)] inline-flex items-center gap-0.5">LinkedIn <ExternalLink size={11} /></a>
        <a href={links[1].href} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--accent)] inline-flex items-center gap-0.5">Support <ExternalLink size={11} /></a>
      </div>
    )
  }

  // compact
  return (
    <div className="flex items-center gap-2 text-xs">
      <a href={links[0].href} target="_blank" rel="noopener noreferrer" className="text-[var(--text-subtle)] hover:text-[var(--accent)]">Abhay</a>
      <span className="text-[var(--text-subtle)]/50">·</span>
      <a href={links[1].href} target="_blank" rel="noopener noreferrer" className="text-[var(--text-subtle)] hover:text-[var(--accent)]">coffee</a>
    </div>
  )
}
